import { translate } from "app/filters/i18nFilter";
import { columnKeys } from "app/pages/sales-intelligence/utils/i18n/columns";

import type { SimilarwebFieldsConfig } from "app/pages/sales-intelligence/common-components/export-table/types";
import { similarwebValueType } from "app/pages/sales-intelligence/common-components/export-table/valueType";

const OPPORTUNITY_LIST_NAME_FIELD = "opportunity_list_name";

export const getOpportunityListFieldsConfig = (): SimilarwebFieldsConfig => {
    const config: SimilarwebFieldsConfig = {
        [OPPORTUNITY_LIST_NAME_FIELD]: {
            name: translate(columnKeys.title("opportunity_list_name")),
            example: "My Account List",
            field: "opportunity_list_name",
            valueType: similarwebValueType.Text,
        },
    };

    return Object.seal(config);
};

export const getOpportunityListFieldsKeys = () => Object.keys(getOpportunityListFieldsConfig());
